/* eslint-disable */
(function() {
    angular
        .module('MktzapApp.Controllers')
        .requires
        .push(
            'ngTable'
        );

    angular.module('MktzapApp.Controllers')
        .controller('ReportIn100TransactionsController', reports);

    reports.$inject = ['$scope', '$http', 'LangService', 'NotificationService', 'In100ReportTransactionsService', 'ngTableParams', 'FoundationApi'];

    function reports($scope, $http, LangService, NotificationService, In100ReportTransactionsService, ngTableParams, FoundationApi) {

        var vm = this;
        $scope.vm = vm;
        $scope.transactions = [];

        vm.screen = true;
        vm.details = false;
        vm.backButton = false;
        vm.request = '';

        vm.closeConfig = closeConfig

        LangService
            .getPageLabels({'page':'menu.reports.in100-transactions'})
            .$promise
            .then(function(data) {
                vm.labels = data.lang;
            });


        vm.filters = {
            fromDate: moment().startOf("month").format("DD/MM/YYYY"),
            toDate: moment().endOf("month").format("DD/MM/YYYY"),
            exportMedalia: false,
        };

        vm.dateSelected = function(type, date) {
            if (type == 'from') {
                vm.pkadayToDate.setMinDate(date);
            }
            if (type == 'to') {
                vm.pkadayFromDate.setMaxDate(date);
            }
        };

        function validateFields() {
            var toDate = moment(vm.filters.toDate, 'DD/MM/YYYY')
            var fromDate = moment(vm.filters.fromDate, 'DD/MM/YYYY')
            if (toDate < fromDate) {
                NotificationService.warningHandler('', 'Data inicial Invalida')
                vm.show = false
                return false
            }
            if (toDate.diff(fromDate, 'days') > 30) {
                vm.show = false
                NotificationService.warningHandler('', 'Periodo maximo de busca de 30 dias')
                return false
            }
            return true
        }

        vm.clearSearch = function () {
            vm.filters.phone = ''
            vm.filters.cpf = ''
            vm.filters.generateTermIntention = ''
            vm.filters.generateTokenIntention = ''
            vm.filters.saveOnMinioIntention = ''
            vm.filters.signTermIntention = ''
            vm.filters.statusP3 = ''
            vm.filters.validateStoneIntention = ''

            vm.tableAround = ''
        }

        vm.goToTheListing = function () {
            vm.screen = true;
            vm.details = false;
            vm.backButton = false;
            vm.informationTransaction = ''
        }

        vm.moreTransactionInformation = function (id) {
            vm.screen = false;
            vm.details = true;
            vm.backButton = true;

            vm.informationTransaction = vm.transactionsTable.data.find(transaction => transaction._id == id)

            vm.in100TransactionsTableParams = new ngTableParams({
                page: 1,
                count: 10,
            }, {
                data: vm.informationTransaction.actions.in100_term.transactions
            })
        }

        vm.transactionRequest = function (request) {
            FoundationApi.publish('in100TransactionModal', 'open');
            vm.request = JSON.stringify(request, null, 2);
        }

        vm.getTransactions = function () {
            vm.tableAround = false;
            vm.transactionsTable = new ngTableParams({
                page: 1, // show first page
                count: 30, // count per page
            }, {
                counts: [25, 50, 100],
                getData: function ($defer, params) {
                    var obj = params.url();
                    obj = {
                        page: obj['page'],
                        count: obj['count'],
                        filters: vm.filters
                    }

                    In100ReportTransactionsService
                        .paged(obj)
                        .$promise
                        .then(function (retorno) {

                            if(retorno.success === false) {
                                NotificationService.warningHandler(retorno, retorno.message)
                                return;
                            }

                            params.total(retorno.result.total)
                            $defer.resolve(retorno.result.data)
                            vm.data_total = retorno.result.total
                            vm.data_result = retorno.result.data.length
                            vm.tableAround = true
                        }).catch(function ({data}) {
                          const errors = data.errors.validation

                          if(errors){
                            errors.map(function(message){
                              NotificationService.warningHandler(null,message)
                            })
                          }else{
                            NotificationService.errorHandler(null,data.errors)
                          }

                        })
                }
            })

        }

        vm.downloadTransactions = function() {
            vm.filters.exportMedalia = true;
            vm.filters.isSearch = false;

            $http.get(apiUrl + '/reports/in100-transactions-download', {
                    params: {
                        filters: vm.filters
                    }
                })
                .then(function({ data }) {
                    if (data.warning) {
                        NotificationService.warningHandler(data, data.message)
                        return
                    }
                    const success = prepareFileForDownload(data)
                    if (!success) {
                        NotificationService.warningHandler(data, $scope.labels.noRecord)
                    }
                }, function() {
                    NotificationService.errorHandler('', $scope.labels.errorReport)
                })
        }

        function prepareFileForDownload(data) {
            let component = angular.element('<a/>')
            component.css({ display: 'none' })
            angular.element(document.body).append(component)

            let blob = new Blob([data], { type: 'text/csv' })

            if (blob.size <= 58) {
                return false
            }

            let csvUrl = URL.createObjectURL(blob)

            component.attr({
                href: csvUrl,
                target: '_self',
                download: 'In100_Transactions.csv'
            })[0].click()

            component.remove()
            URL.revokeObjectURL(csvUrl)

            return true
        }

        function closeConfig () {
            FoundationApi.publish('in100TransactionModal', 'close')
        }
    }
})();
